export default __webpack_public_path__ + "static/media/lucky-spin-banner.62168e84.webp";